"use client";

import { c as _c } from "react/compiler-runtime";
import { ReadOnlyCarePlan } from "@/components/care-plan/read-only-care-plan";
import { useCarePlansForPatient } from "@/hooks/use-care-plans-for-patient";
import { PatientSidebarSectionSkeleton } from "./section-skeleton";
interface Props {
  patientId: string;
}
export default function CarePlansSection(t0) {
  const $ = _c(10);
  const {
    patientId
  } = t0;
  const {
    data: carePlans,
    isPending,
    isError
  } = useCarePlansForPatient(patientId);
  if (isPending) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PatientSidebarSectionSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isError) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-caption text-status-error-text">Failed to load care plans</p>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (!carePlans || carePlans.length === 0) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-caption text-muted-foreground">No active care plans</p>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== carePlans || $[4] !== patientId) {
    let t2;
    if ($[6] !== patientId) {
      t2 = cp => <ReadOnlyCarePlan key={cp.id} carePlan={cp} patientId={patientId} orientation="vertical" size="sm" />;
      $[6] = patientId;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = carePlans.map(t2);
    $[3] = carePlans;
    $[4] = patientId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div className="space-y-3">{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}